import { Box, Stack } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import discoLightLaptop from '@assets/images/discoLightLaptop.png';
import Button from '@mui/material/Button';
import { useShallow } from 'zustand/react/shallow';
import { useQualificationFlowStore } from '@store/qualificationStore/qualificationStore';
import { formatReceivedAddress } from '@utils/formatReceivedAddress';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useCustomer } from '@contexts/CustomerContext';

export const AddressHeader = () => {
  const { branding } = useCustomer();
  const heroSrc = branding.heroImage ?? discoLightLaptop;

  const { setQualificationFlow, receivedAddress } = useQualificationFlowStore(
    useShallow((s) => ({
      setQualificationFlow: s.setQualificationFlow,
      receivedAddress: s.qualificationResult?.serviceQualificationItem?.receivedAddress,
    }))
  );

  const formattedAddress = receivedAddress ? formatReceivedAddress(receivedAddress) : '';

  const handleChangeAddress = (): void => {
    setQualificationFlow((prev) => ({ ...prev, isChangeAddressOpen: true }));
  };

  return (
    <Stack>
      <Paper variant="heroBanner">
        <Container>
          <Stack
            direction={{ xs: 'column', lg: 'row' }}
            alignItems={{ xs: 'flex-start', lg: 'center' }}
            justifyContent="space-between"
            gap={{ xs: '16px', lg: '90px' }}
            width="100%"
          >
            <Stack gap={{ xs: '16px', lg: '30px' }} width={{ xs: '100%', lg: '576px' }} flexShrink={0} zIndex={2}>
              <Typography variant="heading.hero" className="AddressHeader-heading">
                <Typography component="span" variant="inherit" color="inherit" className="AddressHeader-highlight">
                  {`Great News!`}
                </Typography>
              </Typography>
              <Typography variant="heading.hero" className="AddressHeader-heading">
                {[branding.portalName, branding.heroTagline].filter(Boolean).join(' ')}
              </Typography>

              <Stack className="AddressHeader-card" gap="6px" borderRadius="10px" p="15px">
                <Typography variant="subtitle.section">{"Here's What's Available At:"}</Typography>
                <Stack gap="10px" direction="row" alignItems="center" mb="20px">
                  <LocationOnIcon fontSize="medium" sx={{ ml: '-5px' }} />
                  <Typography variant="body.lead">{formattedAddress}</Typography>
                </Stack>

                <Button variant="changeAddress" onClick={handleChangeAddress}>
                  CHANGE ADDRESS
                </Button>
              </Stack>
            </Stack>

            <Box
              className="AddressHeader-heroImage"
              display="flex"
              order={{ xs: -1, lg: 0 }}
              alignItems="center"
              justifyContent="center"
              flexShrink={1}
              zIndex={1}
            >
              <img src={heroSrc} alt="Laptop" />
            </Box>
          </Stack>
        </Container>
      </Paper>
    </Stack>
  );
};
